import { FC, useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router"
import CardSizeDropdown from "./CardSizeDropdown"
import LocationToggle from "./LocationToggle"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { Icon } from "@/components/shared/Icon"
import { PageRoutes } from "@/constants/routes"
import { CardSize, Token } from "@/types/index"
import "./index.scss"

const cardSizeOptions = [
   { label: "Small", value: CardSize.SMALL },
   { label: "Medium", value: CardSize.MEDIUM },
   { label: "Large", value: CardSize.LARGE },
]

const Preferences: FC = () => {
   const navigate = useNavigate()
   const onClickButton = () => {
      navigate(PageRoutes.FLOOR_OVERVIEW)
   }

   const [cellCardSize, setCellCardSize] = useState<string>(() => {
      return localStorage.getItem(Token.CELL_CARD_SIZE) ?? CardSize.LARGE
   })

   const [smartwatchCardSize, setSmartwatchCardSize] = useState<string>(() => {
      return localStorage.getItem(Token.SMARTWATCH_CARD_SIZE) ?? CardSize.MEDIUM
   })

   const createCardOptions = (selectedValue: string) =>
      cardSizeOptions.map((option) => ({
         ...option,
         selected: option.value === selectedValue,
      }))

   const cellCardOptions = useMemo(
      () => createCardOptions(cellCardSize),
      [cellCardSize]
   )

   const smartwatchCardOptions = useMemo(
      () => createCardOptions(smartwatchCardSize),
      [smartwatchCardSize]
   )

   useEffect(() => {
      localStorage.setItem(Token.CELL_CARD_SIZE, cellCardSize)
      localStorage.setItem(Token.SMARTWATCH_CARD_SIZE, smartwatchCardSize)
   }, [cellCardSize, smartwatchCardSize])

   return (
      <Grid
         direction="column"
         flexWrap="nowrap"
         className="preferences"
      >
         <GridItem size={12}>
            <div
               className="preferences__back-button"
               onClick={onClickButton}
            >
               <Icon
                  size="16"
                  name="arrowLeft"
                  className="preferences__back-button-icon"
               />
               <span>Go back to Floor Overview</span>
            </div>
            <h1 className="preferences__title">Preferences</h1>
         </GridItem>

         <LocationToggle
            title="Display Location"
            description="Choose whether to display location or not"
         />

         <CardSizeDropdown
            title="Cell Card Size"
            description="Choose the cell card size"
            dropdownLabel="Cell card size"
            options={cellCardOptions}
            onChange={(value) => setCellCardSize(value)}
         />

         <CardSizeDropdown
            title="Inmate Card Size"
            description="Choose the inmate card size"
            dropdownLabel="Inmate card size"
            options={smartwatchCardOptions}
            onChange={(value) => setSmartwatchCardSize(value)}
         />
      </Grid>
   )
}

export default Preferences
